import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Template } from 'app/models/template.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  private apiUrl = `${environment.baseUrl}/Template`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }

  getTemplateList(): Observable<any> {
    // return this.http.get(`${this.apiUrl}/getTemplateList`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getTemplateList`);
  }

  getTemplateWithSC(shortcode: string): Observable<any> {
    console.log(`${this.apiUrl}/getTemplatewithSC/${shortcode}`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getTemplatewithSC/${shortcode}`);
    // return this.http.get(`${this.apiUrl}/getTemplatewithSC/${shortcode}`);
  }

  saveTemplate(template: any): Observable<any> {

    const headers = new HttpHeaders({
              'Content-Type': 'application/json'
            });
            let body = {
              "criteria": {

                "MTShortCode":template.MTShortCode,
                 "MTDescription":template.MTDescription,
                  "MTPropertyArr":template.MTPropertyArr,
                  tenant : null
                    }
            };
    
        return this.commonAPI.postApiCall(`${this.apiUrl}/SaveTemplate`, body);
        // return this.http.post(`${this.apiUrl}/AddProject`, projectData);
   
  }

  getValueTypes(): Observable<any> {
    return this.commonAPI.getApiCall(`${this.apiUrl}/getValuetypes`);
  }

  getReadingMaterialTypes(): Observable<any> {
    return this.commonAPI.getApiCall(`${this.apiUrl}/getReadingMaterialTypes`);
  }

  deleteTemplate(shortcode: string): Observable<any> {

    const headers = new HttpHeaders({
              'Content-Type': 'application/json'
            });
            let body = {
              "criteria": {

                "MTShortCode": shortcode,
                 tenant : null
                    }
            };
    
        return this.commonAPI.postApiCall(`${this.apiUrl}/DeleteTemplate`, body);
   // return this.commonAPI.deleteApiCall(`${this.apiUrl}/DeleteTemplate/${shortcode}`);
    // return this.http.delete(`${this.apiUrl}/DeleteTemplate/${shortcode}`);
  }
}

